import {type FC, useMemo, useRef} from 'react';
import type {CameraType} from 'react-camera-pro';
import {Camera as CameraCmp} from 'react-camera-pro';

import {useI18n} from '@yourcoach/i18n';

import * as S from './styles';

export const Camera: FC = props => {
  const {t} = useI18n();
  const camera = useRef<CameraType>(null);

  const errors = useMemo(
    () => ({
      canvas: t('shared:Conference.camera.canvas_error'),
      noCameraAccessible: t('shared:Conference.camera.no_camera_error'),
      permissionDenied: t('shared:Conference.camera.access_denied_error'),
      switchCamera: t('shared:Conference.camera.switch_camera_error'),
    }),
    [t],
  );

  return (
    <S.Container {...props}>
      <CameraCmp errorMessages={errors} ref={camera} />
    </S.Container>
  );
};
